import { CSSProperties } from 'react';

import clsx from 'clsx';

import styles from './loadingCircle.module.css';

type LoadingCircleSize = 'sm' | 'md' | 'lg';

const getScale = (size: LoadingCircleSize) => {
	switch (size) {
		case 'lg':
			return 2;
		case 'md':
			return 1.5;
		default:
			return 1;
	}
};

type LoadingCircleProps = {
	className?: string;
	size?: LoadingCircleSize;
};

/**
 * Loading circle. Suitable for placing where an async request is being awaited (ex: inside a submit button)
 */
export const LoadingCircle = ({ className, size = 'sm' }: LoadingCircleProps) => {
	const scale = getScale(size);
	return (
		<div
			style={{ '--scale': scale } as CSSProperties}
			className={clsx(styles.root, className)}
		>
			<span className={styles.inner} />
		</div>
	);
};
